<template>
  <div
    style="max-width: 400px"
    class="pointer"
    @click="downloadFile">
    <el-image
      v-if="showThumb === true && thumb && thumb != ''"
      :src="thumb" />
    <div class="d-flex px-1 py-1 j align-items-center">
      <el-image
        :src="fileTypeIcon(fileExt)"
        class="mt-1"
        style="max-width: 24px; max-height: 30px; min-width: 24px; min-height: 30px" />
      <div class="ms-3 flex-1">
        <el-tooltip
          :content="title"
          placement="top">
          <div
            style="word-break: break-word; white-space: normal"
            class="font-14 fw-500 text-1-line">
            {{ title }}
          </div>
        </el-tooltip>
        <div class="font-10">{{ fileExt.toLocaleUpperCase() + " ∙ " + getFileSize(fileSize) }}</div>
      </div>
      <div class="mx-1 py-1"></div>
      <!-- <div class="message-icon-download pointer">
        <el-tooltip
          content="Tải xuống"
          placement="right"
          effect="light">
          <el-image
            src="/assets/icon/ic_download.png"
            fit="contain"
            @click="downloadFile" />
        </el-tooltip>
      </div> -->
    </div>

    <el-progress
      v-if="percentage > 0"
      :percentage="percentage"
      :color="colors"
      class="w-100 ps-3 py-1"></el-progress>
  </div>
</template>

<script>
export default {
  name: "ChatFileV2",
  props: {
    thumb: {
      type: String,
    },
    fileExt: {
      type: String,
    },
    fileSize: [Number, String],
    href: {
      type: String,
    },
    title: {
      type: String,
    },
    showThumb: {
      default: true,
      type: Boolean,
    },
    accountId: { type: String },
    messageId: { type: Object },
    messageTs: { type: String },
  },
  data() {
    return {
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      percentage: 0,
      timeInterval: null,
    };
  },
  methods: {
    downloadFile() {
      console.log("V2");

      if (this.percentage > 0) return;
      this.calculatePercentage();
      const msg = this.app.replaceLink.find(msg => msg.msgId == this.messageId.msgId);
      const FIFTEEN_DAYS_MS = 10 * 24 * 60 * 60 * 1000;
      const now = Date.now();
      if (msg !== undefined && msg.link && (now - Number(this.messageTs)) >= FIFTEEN_DAYS_MS) {
        const fileUrl = msg.link;
        this.downSetup(fileUrl, this.title);
        return;
      }
      this.$http
        .post("/api/file", this.messageId, {
          params: { accountId: this.accountId },
          responseType: "blob",
        })
        .then((response) => {
          this.percentage = 0;
          this.downSetup(response, this.title);
        })
        .catch(() => {
          this.alertError("Có lỗi xảy ra khi tải file.");
        })
        .finally(() => {
          this.percentage = 0;
        });
    },
    calculatePercentage() {
      let bytesPerSecond = 2440000;
      this.timeInterval = setInterval(() => {
        let toAddPercentage = Math.ceil((bytesPerSecond / this.fileSize) * 100);
        this.percentage += toAddPercentage;

        if (this.percentage + toAddPercentage >= 90) {
          this.percentage = 0;
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
  },
};
</script>

<style scoped></style>
